import { getActiveDate } from "./dates";
import { getTemplateData } from "./getTemplateData";
import { monthUI } from "./monthUI";
import { getPageEntry } from "./pageEntry";
import { getPlanByDate } from "./readingPlan";
import { resetAbortHandling } from "./resetAbortHandling";
import { getReadingViewType } from "./setReadingViewType";
import { stylesCSS } from "./styles-css";
import { getTemplate } from "./templates";
import { weekUI } from "./weekUI";
export function refreshContent() {
    var _a, _b;
    console.log("refresh content");
    resetAbortHandling();
    const templateData = getTemplateData(getPlanByDate(getActiveDate()));
    const readingViewType = getReadingViewType();
    // TODO: we shouldn't need to refresh the styles everytime
    getPageEntry().innerHTML = `
        <style>
        ${stylesCSS()}
        </style>
        <article class="bible-reading ${readingViewType === "month" ? "month" : "week"}">
            <div class="bible-reading__controls">
                <ul class="bible-reading__action print-hide">
                <li>
                    <button class="bible-reading__print-btn bible-reading__action-btn" title="Print reading plan">
                    <i class="fa-solid fa-print"></i>
                    </button>
                </li>
                </ul>
                <ul class="bible-reading__toggle print-hide">
                <li>
                    <button class="bible-reading__action-btn bible-reading__types-btn ${readingViewType === "week" && "active"}" title="7 Day View" value="week" ${readingViewType === "week" && "active"}>
                    <i class="fas fa-list-ol"></i>
                    </button>
                </li>
                <li>
                    <button class="bible-reading__action-btn bible-reading__types-btn ${readingViewType === "month" && "active"}" title="Calendar Month View" value="month">
                    <i class="far fa-calendar"></i>
                    </button>
                </li>
                </ul>
                <header class="bible-reading__header">
                <button class="bible-reading__paginate-btn print-hide" title="Previous ${readingViewType}" value="previous">
                    <i class="fas fa-solid fa-chevron-left"></i>
                </button>
                <button class="bible-reading__paginate-btn bible-reading__type-title">${readingViewType === "month"
        ? ((_a = getTemplate("monthlyHeadline")) === null || _a === void 0 ? void 0 : _a(templateData)) ||
            "Monthly"
        : ((_b = getTemplate("weeklyHeadline")) === null || _b === void 0 ? void 0 : _b(templateData)) ||
            "Weekly"}</button>
                <button class="bible-reading__paginate-btn print-hide" title="Next ${readingViewType}" value="next">
                    <i class="fas fa-solid fa-chevron-right"></i>
                </button>
                </header>
            </div>
            <div class="bible-reading__content">
                ${readingViewType === "month" ? monthUI() : weekUI()}
            </div>
        </article>
    `;
}
